<template>
    <div style="height: 100%">
        <!-- 页面头部工具栏 -->
        <div class="page-toolbar">
            <!-- 搜索筛选卡片 -->
            <div class="filter-card">
                <div class="filter-header">
                    <span class="filter-title">
                        <i class="el-icon-search"></i> 筛选条件
                    </span>
                    <el-button type="text" size="mini" @click="resetSearch">重置</el-button>
                </div>
                <div class="filter-content">
                    <div class="filter-item">
                        <label>姓名</label>
                        <el-input v-model="formDatas.auName" size="mini" placeholder="请输入" clearable></el-input>
                    </div>
                    <div class="filter-item">
                        <label>手机号</label>
                        <el-input v-model="formDatas.aubcPhone" size="mini" placeholder="请输入" clearable></el-input>
                    </div>
                    <div class="filter-item">
                        <label>状态</label>
                        <el-select v-model="formDatas.aubcStaus" placeholder="请选择" size="mini" @change="partserch"
                            clearable>
                            <el-option label="待处理" :value="1"></el-option>
                            <el-option label="已发送" :value="2"></el-option>
                            <el-option label="发送失败" :value="3"></el-option>
                            <el-option label="已提交" :value="4"></el-option>
                            <el-option label="待修改" :value="5"></el-option>
                            <el-option label="已通过" :value="6"></el-option>
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <label>是否有浦发卡</label>
                        <el-select v-model="formDatas.hasPufaCard" placeholder="请选择" size="mini" @change="partserch"
                            clearable>
                            <el-option label="有" value="true"></el-option>
                            <el-option label="无" value="false"></el-option>
                        </el-select>
                    </div>
                    <div class="filter-item filter-btn">
                        <el-button type="primary" size="mini" icon="el-icon-search" @click="partserch">查询</el-button>
                    </div>
                </div>
            </div>
            <!-- 操作工具栏 -->
            <div class="action-toolbar">
                <div class="action-left">
                    <el-button type="warning" size="mini" plain icon="el-icon-message"
                        @click="BulkSend">发送钉钉通知</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-button type="success" size="mini" plain icon="el-icon-check"
                        @click="openBatchAudit">批量审核</el-button>
                    <el-button type="danger" size="mini" plain icon="el-icon-delete"
                        @click="BulkDelete">批量删除</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-button type="primary" size="mini" plain icon="el-icon-download"
                        @click="handleExport">导出Excel</el-button>
                </div>
                <div class="action-right">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="BoxOpen">新增收集记录</el-button>
                </div>
            </div>
        </div>
        <div class="tablemain" :style="{ height: tableMainHeight }">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aubcId" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增收集记录抽屉 -->
            <el-drawer :wrapperClosable="false" title="新增收集记录" :before-close="handleClose" :visible.sync="dialog"
                direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="选择花名册用户" prop="auIds">
                                <el-radio-group v-model="isSbAsType">
                                    <el-radio label="0">选择花名册用户</el-radio>
                                    <el-radio label="1">上传文件</el-radio>
                                </el-radio-group>
                                <div v-if="isSbAsType == '0'" style="margin-top: 10px;">
                                    <el-select v-model="form.auIds" multiple filterable clearable
                                        placeholder="请选择用户" style="width: 80%;">
                                        <el-option v-for="item in getAjUserListSimple_data" :key="item.auId"
                                            :label="item.auName" :value="item.auId">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div v-if="isSbAsType == '1'" style="margin-top: 10px;">
                                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls"
                                        :on-change="updatabulk" :auto-upload="false" ref="bulk" multiple>
                                        <el-button size="medium" type="danger">点击上传</el-button>
                                    </el-upload>
                                    <div v-if="form.auIds.length > 0">已选择{{ form.auIds.length }}个用户</div>
                                    <div v-if="arrFail.length > 0">无效用户:</div>
                                    <el-table v-if="arrFail.length > 0" :data="arrFail" stripe border
                                        style="width: 100%" :max-height="300"
                                        :cell-style="{ textAlign: 'center' }"
                                        :header-cell-style="{ textAlign: 'center', background: 'rgba(0,170,255,0.5)', color: 'black', border: 'none' }">
                                        <el-table-column prop="auName" label="姓名"></el-table-column>
                                    </el-table>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">确 定</el-button>
                </div>
            </el-drawer>
            <!-- 查看详情弹窗 -->
            <el-dialog title="银行卡信息详情" :visible.sync="diaDetail" width="700px">
                <el-descriptions :column="2" border size="medium">
                    <el-descriptions-item label="姓名">{{ detailData.auName }}</el-descriptions-item>
                    <el-descriptions-item label="手机号">{{ detailData.aubcPhone }}</el-descriptions-item>
                    <el-descriptions-item label="是否有浦发卡">
                        <el-tag v-if="detailData.hasPufaCard === 'true'" type="success" size="mini">有</el-tag>
                        <el-tag v-else-if="detailData.hasPufaCard === 'false'" type="info" size="mini">无</el-tag>
                        <span v-else>未填写</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="账户类别">{{ detailData.pufaCardLevel || '未填写' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="银行卡号" :span="2">{{ detailData.pufaCard || '未填写' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="开户行" :span="2">{{ detailData.pufaBank || '未填写' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="申请截图" :span="2">
                        <span v-if="detailData.pufaRegisterImage">
                            <el-image v-for="(img, idx) in parseImages(detailData.pufaRegisterImage)" :key="idx"
                                :src="img" fit="fill"
                                style="width: 80px; height: 50px; margin-right: 6px; cursor: pointer;"
                                :preview-src-list="parseImages(detailData.pufaRegisterImage)"></el-image>
                        </span>
                        <span v-else>未上传</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="收件人姓名">{{ detailData.aubcUserName || '未填写' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="收件人电话">{{ detailData.aubcUserPhone || '未填写' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="收件地址" :span="2">{{ detailData.aubcUserAddress || '未填写' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="状态">
                        <el-tag v-if="detailData.aubcStaus === 1">待处理</el-tag>
                        <el-tag v-else-if="detailData.aubcStaus === 2" type="success">已发送</el-tag>
                        <el-tag v-else-if="detailData.aubcStaus === 3" type="danger">发送失败</el-tag>
                        <el-tag v-else-if="detailData.aubcStaus === 4" type="primary">已提交</el-tag>
                        <el-tag v-else-if="detailData.aubcStaus === 5" type="warning">待修改</el-tag>
                        <el-tag v-else-if="detailData.aubcStaus === 6" type="success">已通过</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="审核备注">{{ detailData.aubcDes || '无' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="创建时间">{{ detailData.createtime }}</el-descriptions-item>
                    <el-descriptions-item label="提交时间">{{ detailData.submittime || '未提交' }}
                    </el-descriptions-item>
                </el-descriptions>
            </el-dialog>
            <!-- 批量审核弹框 -->
            <el-dialog title="批量审核" :visible.sync="batchAuditDialog" width="500px"
                :before-close="closeBatchAudit">
                <el-form :model="batchAuditForm" label-width="100px">
                    <el-form-item label="审核结果">
                        <el-radio-group v-model="batchAuditForm.auditType">
                            <el-radio :label="6">通过审核</el-radio>
                            <el-radio :label="5">驳回审核</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="审核备注">
                        <el-input v-model="batchAuditForm.remark" type="textarea" :rows="3"
                            placeholder="请输入审核备注"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeBatchAudit">取 消</el-button>
                    <el-button type="primary" @click="submitBatchAudit">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getAjUserBackCollectList, addAjUserBackCollect,
    deleteAjUserBackCollect, updateAjUserBackCollectCheck,
    updateAjUserBackCollectSend, getAjUserListSimple,
    uploadAjUserReturnIdsList
} from "../../api/api";
import axios from 'axios';
import config from '../../api/env.js';
import qs from 'qs';

export default {
    name: "bankCardCollect",
    data() {
        return {
            // 花名册用户列表
            getAjUserListSimple_data: [],
            // 批量审核
            batchAuditDialog: false,
            batchAuditForm: { auditType: 6, remark: '' },
            // 上传文件无效用户
            arrFail: [],
            // 选择模式：0=花名册选择 1=上传文件
            isSbAsType: '0',
            // 表格主键字段
            key: 'aubcId',
            // 新增弹窗
            dialog: false,
            form: { auIds: [] },
            rules: {},
            // 详情弹窗
            diaDetail: false,
            detailData: {},
            // 复选框
            selectedRowKeysCollection: [],
            checkboxOption: {
                selectedRowKeys: [],
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            // 表格区域动态高度（扣除工具栏后剩余空间）
            tableMainHeight: '90%',
            totalCount: 0,

            // 表格列定义
            columns: [
                {
                    field: "", key: "checkbox", type: "checkbox",
                    fixed: 'left', title: "", width: 50, align: "center",
                },
                {
                    field: "", key: "a", title: "序号", width: 50, fixed: 'left', align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => { return ++rowIndex; },
                },
                { field: "auName", key: "auName", title: "姓名", align: "center", width: 100 },
                { field: "aubcPhone", key: "aubcPhone", title: "手机号", align: "center", width: 130 },
                {
                    // 是否有浦发卡
                    field: "hasPufaCard", key: "hasPufaCard", title: "是否有浦发卡", align: "center", width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.hasPufaCard === 'true') return <el-tag size="mini" type="success">有</el-tag>;
                        if (row.hasPufaCard === 'false') return <el-tag size="mini" type="info">无</el-tag>;
                        return <span style="color:#909399">未填写</span>;
                    },
                },
                { field: "pufaCard", key: "pufaCard", title: "银行卡号", align: "center", width: 200 },
                { field: "pufaBank", key: "pufaBank", title: "开户行", align: "center", width: 160 },
                { field: "pufaCardLevel", key: "pufaCardLevel", title: "账户类别", align: "center", width: 90 },
                {
                    // 申请截图
                    field: "pufaRegisterImage", key: "pufaRegisterImage", title: "申请截图", align: "center", width: 250,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (!row.pufaRegisterImage) return <span></span>;
                        try {
                            const imgs = JSON.parse(row.pufaRegisterImage || '[]');
                            return (
                                <span style="display:flex;align-items:center;">
                                    {imgs.map((item) => {
                                        return <el-image src={item} alt="" fit="fill"
                                            style="width:80px;height:50px;margin-right:4px;"
                                            previewSrcList={imgs}></el-image>;
                                    })}
                                </span>
                            );
                        } catch (e) { return <span></span>; }
                    },
                },
                { field: "aubcUserName", key: "aubcUserName", title: "收件人姓名", align: "center", width: 100 },
                { field: "aubcUserPhone", key: "aubcUserPhone", title: "收件人电话", align: "center", width: 130 },
                { field: "aubcUserAddress", key: "aubcUserAddress", title: "收件地址", align: "center", width: 200 },
                {
                    // 状态
                    field: "aubcStaus", key: "aubcStaus", title: "状态", align: "center", width: 90, fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aubcStaus == 1 ? <el-tag>待处理</el-tag>
                            : row.aubcStaus == 2 ? <el-tag type="success">已发送</el-tag>
                                : row.aubcStaus == 3 ? <el-tag type="danger">发送失败</el-tag>
                                    : row.aubcStaus == 4 ? <el-tag type="primary">已提交</el-tag>
                                        : row.aubcStaus == 5 ? <el-tag type="warning">待修改</el-tag>
                                            : <el-tag type="success">已通过</el-tag>;
                    },
                },
                { field: "aubcDes", key: "aubcDes", title: "审核备注", align: "center", width: 140 },
                { field: "submittime", key: "submittime", title: "提交时间", width: 160, align: "center" },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
                {
                    // 操作列
                    field: "", key: "d", title: "操作", width: 280, align: "center", fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button size="mini" type="text" style="color:#409EFF"
                                    on-click={() => this.handleDetail(row)}>详情</el-button>
                                {row.aubcStaus == 4 ? <el-button size="mini" type="text" style="color:green"
                                    on-click={() => this.handleUp(row)}>通过审核</el-button> : ''}
                                {row.aubcStaus == 4 ? <el-button size="mini" type="text" style="color:red"
                                    on-click={() => this.handleReject(row)}>驳回审核</el-button> : ''}
                                <el-button size="mini" type="text" style="color:red"
                                    on-click={() => this.handleDelete(row)}>删除</el-button>
                            </span>
                        );
                    },
                },
            ],

            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 20,
            },
        };
    },

    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.updateTableHeight();
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.updateTableHeight();
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },

    created() {
        this.windheight = this.$store.state.windheight;
        // 加载花名册用户列表
        getAjUserListSimple({ pageSize: 0, checkStatus: 2 }).then(res => {
            this.getAjUserListSimple_data = res.data;
        });
        this.getList();
        // 首次渲染后动态计算表格高度
        this.$nextTick(() => { this.updateTableHeight(); });
    },

    methods: {
        // ========== 列表查询 ==========
        partserch() {
            this.formDatas.currentPage = 1;
            getAjUserBackCollectList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            });
        },
        getList() {
            getAjUserBackCollectList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        resetSearch() {
            this.formDatas = { currentPage: 1, pageSize: 20 };
            this.getList();
        },

        /**
         * 动态计算表格高度
         * 根据实际工具栏高度自适应，确保表格+分页在一屏内完整展示
         */
        updateTableHeight() {
            const wh = this.$store.state.windheight;
            this.windheight = wh;
            this.$nextTick(() => {
                const toolbar = this.$el ? this.$el.querySelector('.page-toolbar') : null;
                const toolbarH = toolbar ? toolbar.offsetHeight : 200;
                // 视口高度 - 顶部导航(60px) - 工具栏实际高度 - tablemain margin(~2%) - tablecss padding(20px) - 分页(~50px)
                const mainH = wh - 60;
                const marginH = Math.round(mainH * 0.02);
                const available = mainH - toolbarH - marginH * 2 - 20 - 50;
                this.tableHight = Math.max(available, 200);
                // 同步更新 tablemain 高度，避免固定 90% 导致溢出
                this.tableMainHeight = (mainH - toolbarH - marginH * 2) + 'px';
            });
        },

        // ========== 分页 ==========
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            getAjUserBackCollectList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            });
        },

        // ========== 复选框 ==========
        resetSelectedRowKeys(key) {
            this.checkboxOption.selectedRowKeys = [];
            const collection = this.selectedRowKeysCollection;
            if (collection.length) {
                this.tableData.forEach((item) => {
                    if (collection.indexOf(item[key]) > -1) {
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        changeSelectAll(isSelected, selectedRowKeys, key) {
            this.checkboxOption.selectedRowKeys = selectedRowKeys;
            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item) => {
                    const idx = this.selectedRowKeysCollection.indexOf(item[key]);
                    if (idx > -1) {
                        this.selectedRowKeysCollection.splice(idx, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
            } else {
                const idx = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(idx, 1);
                const idx2 = this.selectedRowKeysCollection.indexOf(rowKey);
                this.selectedRowKeysCollection.splice(idx2, 1);
            }
        },

        // ========== 新增 ==========
        BoxOpen() {
            this.form = { auIds: [] };
            this.arrFail = [];
            this.isSbAsType = '0';
            this.dialog = true;
        },
        handleClose() {
            this.dialog = false;
            this.form = { auIds: [] };
            this.arrFail = [];
            if (this.$refs['formRef']) {
                this.$refs['formRef'].resetFields();
            }
        },
        SureBtn() {
            if (this.form.auIds.length === 0) {
                this.$message({ showClose: true, message: "请选择用户", type: 'warning' });
                return;
            }
            this.$confirm("是否确定要新增收集记录, 是否继续?", "提示", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then(() => {
                this.openLoading();
                const newForm = { auIds: JSON.stringify(this.form.auIds) };
                addAjUserBackCollect(newForm).then(res => {
                    this.loadings.close();
                    if (res.status == 200) {
                        this.$message({ type: "success", message: "新增成功!" });
                        this.handleClose();
                        this.getList();
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },

        // ========== 上传文件解析用户 ==========
        async updatabulk(file, fileList) {
            this.form.auIds = [];
            this.arrFail = [];
            let Data = new FormData();
            Data.append('file', file.raw);
            this.openLoading();
            uploadAjUserReturnIdsList(Data).then(res => {
                if (res.data.length == 0) {
                    this.$message({ showClose: true, message: "上传失败，请检查文件内容", type: 'danger' });
                    this.loadings.close();
                    return;
                }
                this.loadings.close();
                res.data.forEach((item) => {
                    if (item.auId) {
                        this.form.auIds.push(item.auId);
                    } else {
                        this.arrFail.push(item);
                    }
                });
            });
        },

        // ========== 删除 ==========
        handleDelete(row) {
            this.$confirm("是否确定要删除该条记录吗?", "提示", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then(() => {
                deleteAjUserBackCollect({ aubcId: row.aubcId }).then(res => {
                    if (res.data) {
                        this.$message({ type: "success", message: "删除成功!" });
                        this.partserch();
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({ showClose: true, message: "请选择需要删除的数据", type: 'warning' });
                return;
            }
            this.$confirm(`是否确定要删除选中的 ${this.selectedRowKeysCollection.length} 条记录?`, "提示", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then(() => {
                // 逐条删除
                const promises = this.selectedRowKeysCollection.map(id =>
                    deleteAjUserBackCollect({ aubcId: id })
                );
                Promise.all(promises).then(() => {
                    this.$message({ type: "success", message: "批量删除成功!" });
                    this.checkboxOption.selectedRowKeys = [];
                    this.selectedRowKeysCollection = [];
                    this.partserch();
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },

        // ========== 审核 ==========
        // 通过审核
        handleUp(row) {
            this.$prompt("请输入审核备注（可选）", "确定通过审核吗?", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then((value) => {
                updateAjUserBackCollectCheck({
                    aubcId: row.aubcId, aubcStaus: 6, aubcDes: value.value
                }).then(res => {
                    this.$message({ type: "success", message: "审核通过!" });
                    this.getList();
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        // 驳回审核
        handleReject(row) {
            this.$prompt("请输入驳回原因", "确定驳回吗?", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then((value) => {
                updateAjUserBackCollectCheck({
                    aubcId: row.aubcId, aubcStaus: 5, aubcDes: value.value
                }).then(res => {
                    this.$message({ type: "success", message: "已驳回!" });
                    this.getList();
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        // 打开批量审核弹窗
        openBatchAudit() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({ showClose: true, message: "请选择需要审核的数据", type: 'warning' });
                return;
            }
            this.batchAuditForm = { auditType: 6, remark: '' };
            this.batchAuditDialog = true;
        },
        closeBatchAudit() {
            this.batchAuditDialog = false;
            this.batchAuditForm = { auditType: 6, remark: '' };
        },
        // 提交批量审核
        submitBatchAudit() {
            const auditText = this.batchAuditForm.auditType === 6 ? '通过' : '驳回';
            this.$confirm(`是否确定批量${auditText}审核选中的 ${this.selectedRowKeysCollection.length} 条数据?`, "提示", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then(() => {
                const params = {
                    aubcIds: JSON.stringify(this.selectedRowKeysCollection),
                    aubcStaus: this.batchAuditForm.auditType,
                    aubcDes: this.batchAuditForm.remark,
                };
                updateAjUserBackCollectCheck(params).then(res => {
                    this.$message({ type: "success", message: "批量审核成功!" });
                    this.checkboxOption.selectedRowKeys = [];
                    this.selectedRowKeysCollection = [];
                    this.batchAuditForm = { auditType: 6, remark: '' };
                    this.batchAuditDialog = false;
                    this.getList();
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },

        // ========== 发送钉钉通知 ==========
        BulkSend() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({ showClose: true, message: "请选择需要发送通知的用户", type: 'warning' });
                return;
            }
            this.$confirm(`是否确定向选中的 ${this.selectedRowKeysCollection.length} 位用户发送钉钉通知?`, "提示", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then(() => {
                this.openLoading();
                updateAjUserBackCollectSend({
                    aubcIds: JSON.stringify(this.selectedRowKeysCollection)
                }).then(res => {
                    this.loadings.close();
                    this.$message({ type: "success", message: "发送成功!" });
                    this.checkboxOption.selectedRowKeys = [];
                    this.selectedRowKeysCollection = [];
                    this.partserch();
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },

        // ========== 导出Excel（文件流方式） ==========
        handleExport() {
            const that = this;
            this.$confirm("是否确定导出当前筛选条件下的数据?", "提示", {
                confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",
            }).then(() => {
                that.openLoading();
                const s = qs.stringify(that.formDatas);
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-user-back-collect/exportAjUserBackCollect',
                    data: s,
                    timeout: 120000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid')
                    }
                }).then(function (res) {
                    that.loadings.close();
                    if (res.data) {
                        const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', '银行卡信息登记.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                        that.$message({ type: "success", message: "导出成功!" });
                    }
                }).catch(function () {
                    that.loadings.close();
                    that.$message({ type: "error", message: "导出失败，请重试" });
                });
            }).catch(() => {
                that.$message({ type: "info", message: "已取消" });
            });
        },

        // ========== 查看详情 ==========
        handleDetail(row) {
            this.detailData = row;
            this.diaDetail = true;
        },
        // 解析图片 JSON 字符串
        parseImages(str) {
            try {
                return JSON.parse(str || '[]');
            } catch (e) {
                return [];
            }
        },

        // ========== 工具方法 ==========
        openLoading() {
            this.loadings = this.$loading({
                lock: true, text: "加载中...", spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* 页面工具栏 */
.page-toolbar {
    background: #fff;
    padding: 16px;
}

/* 筛选卡片 */
.filter-card {
    background: #fafafa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    margin-bottom: 12px;
}

.filter-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    border-bottom: 1px solid #ebeef5;
    background: #fff;
    border-radius: 4px 4px 0 0;
}

.filter-title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
}

.filter-title i {
    margin-right: 6px;
    color: #409EFF;
}

.filter-content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 20px;
    padding: 14px 16px;
}

.filter-item {
    display: flex;
    align-items: center;
    gap: 8px;
}

.filter-item label {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
    min-width: 78px;
    text-align: right;
}

.filter-item .el-input {
    width: 150px;
}

.filter-item .el-select {
    width: 130px;
}

.filter-btn {
    margin-left: auto;
}

/* 操作工具栏 */
.action-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.action-left,
.action-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.action-left .el-divider {
    margin: 0 4px;
}
</style>
